<template>
  <div class="bottom">
    <div class="all">
      <div
        class="rest"
        :style="{
          color: isShort ? 'rgba(253, 36, 36, 1)' : 'rgba(153, 153, 153, 1)'
        }"
      >
        <p>{{ lang('兑换方式') }}</p>
        <div class="restItem" @click="showBtnFn">
          <p>
            {{ checked === '2' ? lang('剩余赠送积分') : lang('剩余充值积分') }}
          </p>
          <p style="font-weight: bold">
            {{ checked === '2' ? props.bonusPoints : props.restScore }}
          </p>
          <img :src="more" />
        </div>
      </div>
    </div>
    <van-popup
      v-model:show="showBottom"
      round
      position="bottom"
      :style="{ height: 'auto' }"
    >
      <div style="margin-bottom: 30px">
        <p style="padding: 20px 16px; font-size: 14px; font-weight: bold">
          {{ lang('兑换方式') }}
        </p>
        <van-radio-group v-model="checked">
          <van-cell-group inset>
            <van-cell
              :title="lang('剩余赠送积分') + props.bonusPoints"
              clickable
              @click="changePay('2')"
            >
              <template #right-icon>
                <van-radio checked-color="#ee0a24" name="2" />
              </template>
            </van-cell>
            <van-cell
              :title="lang('剩余充值积分') + props.restScore"
              clickable
              @click="changePay('1')"
            >
              <template #right-icon>
                <van-radio checked-color="#ee0a24" name="1" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-popup>
    <div class="btn">
      <div class="allBox">
        <p style="font-size: 12px">{{ lang('合计') }}</p>
        <div class="totalBox">
          <img :src="red" />
          <p class="allText">{{ total }}</p>
        </div>
      </div>
      <van-button
        class="btnBox"
        :style="btnBg()"
        round
        :plain="true"
        @click="click()"
      >
        {{ btnText() }}
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import gray from '../../../../assets/images/score/grayBase.png'
import red from '../../../../assets/images/score/redBase.png'
import more from '../../../../assets/images/score/more.png'
import { useRouter } from 'vue-router'
import lang from '@/langs'
const props = defineProps<{
  total: number
  restScore: number
  bonusPoints: number
}>()
//RECHARGE(1,"积分充值"),
//BONUS(2,"冲单激励赠送"),
const total = ref(props.total)
const router = useRouter()
const isShort = ref(false)
const emits = defineEmits(['click', 'payType'])
const showBottom = ref(false)
const checked = ref('1')
const changePay = (value: string) => {
  checked.value = value
  showBottom.value = false
  emits('payType', value)
}
const showBtnFn = () => {
  showBottom.value = true
}
watch(
  () => [props.total, props.restScore, props.bonusPoints, checked.value],
  ([newTotal, newRestScore, newBonusPoints, newChecked]) => {
    total.value = Number(newTotal)
    if (newChecked === '2') {
      isShort.value = newBonusPoints < newTotal
    } else {
      isShort.value = newRestScore < newTotal
    }
  },
  { immediate: true }
)
const click = () => {
  if (isShort.value) {
    router.push({
      path: '/scoreCharge',
      query: { isH5: 'true' }
    })
  } else {
    emits('click')
  }
}
const btnBg = () => {
  if (isShort.value) {
    return {
      background: 'rgba(216, 216, 216, 1)' /* 从左到右的渐变 */
    }
  } else {
    return {
      background:
        'linear-gradient(90deg,rgba(250, 81, 15, 1),rgba(255, 0, 0, 1) 100%)' /* 从左到右的渐变 */
    }
  }
}
const btnText = () => {
  if (isShort.value) {
    return lang('积分不足，去充值')
  } else {
    return lang('兑换')
  }
}
</script>

<style scoped lang="less">
.bottom {
  background: #fff;
  display: flex;
  flex-direction: column;
  .all {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 18px 16px;
    :deep(.van-radio-group) {
      .van-cell {
        padding: 0;
      }
    }
    .rest {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: #6e6e6e;
      font-size: 14px;
      width: 100%;
      .restItem {
        display: flex;
        flex-direction: row;
        align-items: center;
        > p {
          color: #3c3c3c;
          font-size: 14px;
          margin-right: 4px;
        }
        > img {
          width: 16px;
          height: 16px;
          //margin: 0 6px;
        }
      }
    }
  }
  .btn {
    height: 58px;
    width: 100%;
    padding: 6px 16px;
    display: flex;
    flex-direction: row;
    border-top: 1px solid #f2f2f2;
    .allBox {
      display: flex;
      flex-direction: column;
      width: 35%;
      padding-top: 4px;
      > P {
        font-size: 14px;
        font-weight: bold;
        margin-right: 12px;
        color: rgba(60, 60, 60, 1);
      }
      .totalBox {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        margin-top: 4px;
        > img {
          width: 12px;
          height: 12px;
        }
        .allText {
          font-size: 18px;
          color: rgba(255, 0, 0, 1);
          margin-left: 4px;
        }
      }
    }
    .btnBox {
      width: 100%;
      background: linear-gradient(
        90deg,
        rgba(250, 81, 15, 1),
        rgba(255, 0, 0, 1) 100%
      ); /* 从左到右的渐变 */
      color: #fff;
      font-weight: bold;
      font-size: 16px;
    }
    border-top-width: 1px;
    border-top-color: rgba(242, 242, 242, 1);
  }
}
</style>
